"use strict";import r from"./src/theme-light.css.js";import{Theme as e}from"./src/Theme.js";import"./core.js";e.registerThemeFragment("light","color",r);
//# sourceMappingURL=theme-light.js.map
